import { handleFreeShipping } from '../global'
import { _t } from "../base";

function addCloseIconToLoginModal() {
    $('.login-widget .popup-widget-inner').prepend(`<div class="login-close"></div>`)
    $('.login-close').click(function () {
        $('body').removeClass('login-window-visible user-action-visible')
    })
}

function updateSocialLoginButtons() {
    document.querySelectorAll('.login-btn strong').forEach(el => {
        const text = el.textContent.trim().split(' ');
        el.textContent = text[text.length - 1];
    });

    const social = document.querySelector('.social-login-buttons');
    const helper = document.querySelector('.password-helper');

    if (social && helper && helper.parentNode) {
        helper.parentNode.insertBefore(social, helper);
    }
}

function appendPriceAfterName(cartProduct) {
    const cartProductPrice = cartProduct.find('.cart-widget-product-price')

    cartProduct.find('.cart-widget-product-name').append(cartProductPrice)
}

function getCartWidgetBottomHeight() {
    const cartWidgetBottom = $('#header .cart-widget-bottom')
    const height = cartWidgetBottom.outerHeight(true)
    document.documentElement.style.setProperty('--cart-widget-bottom-height', `${height}px`)
}

function cartWidget() {
    $('.cart-widget-product').each(function () {
        const cartProduct = $(this)

        appendPriceAfterName(cartProduct)
    })
    handleFreeShipping()
    getCartWidgetBottomHeight()
}

export function initPopupWidget() {
    addCloseIconToLoginModal()
    updateSocialLoginButtons()
    $('.login-widget .popup-widget-inner > h2')
        .text(_t('login.title'))

    document.addEventListener('ShoptetDOMCartContentLoaded', () => {
        cartWidget()
    })
}
